import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { CandidateProfileList } from 'modules/candidate-profile/components/CandidateProfileList';
import { CandidateProfileListType } from 'modules/candidate-profile/types/CandidateProfileListProps';

export const TalentPoolAddCandidatesPage: React.FC = () => {
  const { getPathParams } = usePathsV2();
  const { talentPoolId } = getPathParams.TALENT_POOL_ADD_CANDIDATES();
  return (
    <CandidateProfileList
      type={CandidateProfileListType.ADD_CANDIDATES_TO_TALENT_POOL}
      talentPoolId={talentPoolId}
    />
  );
};
